import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, Inject } from '@angular/core';

import { ResponsiveVideoComponent } from '../responsive-video/responsive-video.component';

@Component({
  selector: 'app-video-dialog',
  templateUrl: './video-dialog.component.html',
  imports: [ResponsiveVideoComponent],
})
export class VideoDialogComponent {
  constructor(
    public dialogRef: DialogRef<void>,
    @Inject(DIALOG_DATA)
    public data: {
      data: {
        videoURL: string;
      };
    }
  ) {}
}
